import script from "./ListAndFormNewRcd.vue?vue&type=script&setup=true&lang=js"
export * from "./ListAndFormNewRcd.vue?vue&type=script&setup=true&lang=js"

import "./ListAndFormNewRcd.vue?vue&type=style&index=0&id=e90bec3e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e90bec3e"]])

export default __exports__